<template>
  <div class="loan-configuration-section-wrapper">
    <div class="info-section">
      <p class="info-title">Pre-Approved Refinance Loan Amount</p>
      <p class="info-value">{{ preApprovedAmountDisplay }}</p>
    </div>
    <div class="info-section">
      <p class="info-title">
        <span>Interest Rate & Loan Term</span
        ><a
          class="edit-link"
          v-if="canEdit"
          :disabled="!canEdit"
          @click.prevent="openModal('InterestRateAndLoanTerm')"
          >Edit</a
        >
      </p>
      <p class="info-value">{{ interestRateAndLoanTermDisplay }}</p>
    </div>
    <div class="info-section">
      <p class="info-title">
        Estimated Monthly Payment
        <span style="margin-bottom: 20px">
          <tooltip-component class="md-bottom-center">
            <template #toggle>
              <b><icon icon="info" /></b>
            </template>
            <div>
              Payment Estimates – See Your Approval Disclosure in your Legal Packet and your Final
              Disclosure for more details. Actual payment amounts will vary based on the number of
              days in a month and any variable interest rate.
            </div>
          </tooltip-component>
        </span>
      </p>
      <p class="info-value">{{ estimatedMonthlyPaymentDisplay }}</p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { ApplicationStatusTypeIds } from "@/config/constants";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import Icon from "@/components/shared/Icon.vue";

const store = useStore();
const applicationInfo = computed(() => store?.state?.applicationInfoModule?.applicationInfo);
const consentsModule = computed(() => store.state);
const consentsModuleGetters = computed(() => store.getters);
const applicationStatusId = computed(() => store.state.appData?.application?.applicationStatusId);

const preApprovedAmountDisplay = computed(() =>
  applicationInfo.value?.preApprovedAmount
    ? applicationInfo.value?.preApprovedAmount
    : "Not Selected",
);
const interestRateAndLoanTermDisplay = computed(() =>
  applicationInfo.value?.rate &&
  applicationInfo.value?.term &&
  applicationInfo.value?.rate !== "Not Selected" &&
  applicationInfo.value?.term !== "Not Selected"
    ? `${applicationInfo.value?.rate} | ${applicationInfo.value?.term}`
    : "Not Selected",
);
const estimatedMonthlyPaymentDisplay = computed(() =>
  applicationInfo.value?.estimatedMonthlyPayment
    ? applicationInfo.value?.estimatedMonthlyPayment
    : "Not Selected",
);

const canEdit = computed(() => applicationInfo.value?.canEdit);

function openModal(modal: string) {
  store.dispatch("applicationInfoModule/openModal", modal);
}
</script>
<style scoped>
.edit-link {
  color: #767676;
  font-size: 0.8em;
  font-weight: 400;
  margin: 0;
  text-align: end;
  text-decoration: underline;
  cursor: pointer;
}
.info-section {
  width: 100%;
  margin-bottom: 10px;
}
.info-section .info-title {
  font-weight: 700;
  display: flex;
  gap: 1em;
  align-items: center;
}
.info-section .info-value {
  display: flex;
  justify-content: flex-start;
}
.info-section .info-value p:first-child {
  margin-right: 30px;
}
.info-section p {
  margin-bottom: 0;
}
</style>
